<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useSettingsApi } from '../../api/settings/get.hook'
import BannerConfigVault from './BannerConfigVault.vue'
import TableExperiments from './TableExperiments.vue'

defineOptions({
  name: 'SettingsExperimentsPage',
})

onMounted(() => {
  void useSettingsApi()
})

useOnTimezoneChange(() => {
  void useSettingsApi()
})
</script>

<template>
  <BannerConfigVault />
  <TableExperiments />
</template>
